import React from 'react'
import LinearProgress from '@mui/material/LinearProgress';
import styled from 'styled-components'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      labels: {
        color: "black",
        font: {
          size: 12
        }
      }
    },
  },
  scales: {
    x: {
      ticks: {
        color: 'black'  // Color for x-axis tick labels
      },
      stacked: true,
    },
    y: {
      ticks: {
        color: 'black'  // Color for y-axis tick labels
      },
    }
  },
};

const labels = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const LoadingBanner = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  font-size: 3rem;
`
export default function AllroadBarGraphLiveWeek({ weeklyData = {}, projectedData = {} }) {

  const [dataList, setDataList] = React.useState([]);
  const [formattedProjected, setFormattedProjected] = React.useState([])

  React.useEffect(() => {
    if (Object.keys(weeklyData).length > 0) {
      let totalDataList = Object.values(weeklyData).map(item => item.totalHours);
      setDataList(totalDataList);
    }

    if (Object.keys(projectedData).length > 0) {
      let totalDataList = Object.values(projectedData).map(item => item.totalHours);
      setFormattedProjected(totalDataList);
    }
    
  }, [weeklyData, projectedData]);

  const data = {
    labels,
    datasets: [
      {
        label: "Complete",
        data: dataList,
        borderColor: "#FF6347",
        backgroundColor: "#FF6347",
      },
      {
        label: "Projected",
        data: formattedProjected,
        borderColor: '#333333',
        backgroundColor: '#333333',
      },

    ],
  };

  return (
    <>
      <Bar options={options} data={data} />
    </>
  );
}